// appels/create hooks
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { cohortKeys } from "@modules/cohorts/_shared/keys";
import { appelKeys } from "../../_shared/keys";
import { createAppel } from "../services";

/**
 * Creates an appel. The answer goes into the appel cache (its page opens without a second request)
 * and the cohort is reloaded: its page lists its appels.
 */
export function useCreateAppel(cohortId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: {
      body: Record<string, string>;
      idempotencyKey: string;
    }) => createAppel(cohortId, input.body, input.idempotencyKey),
    onSuccess: (appel) => {
      queryClient.setQueryData(appelKeys.detail(appel.id), appel);
      void queryClient.invalidateQueries({ queryKey: cohortKeys.all });
    },
  });
}
